import { ViMonitorListItemApi } from '../../api/visibilityIntelligence/models/vi-monitor-list-item.api.model';
import { ViMonitorStatusEnum } from '../enums/vi-monitor-status.enum';
import { LeftSidebarListItem } from '../../Common/Layout/models/left-sidebar-list-item.model';
import { LeftSidebarListItemButton } from '../../Common/Layout/models/left-sidebar-list-item-button.model';
import { LeftSidebarListItemConvertableModel } from '../../Common/Layout/models/left-sidebar-list-item-convertable.model';
import { AuditableModel } from '../../Common/Misc/models/auditable.model';
import { ActionsEnum } from '../../Common/Basic/enums/actions.enum';
import { BaseModel } from '../../Common/Basic/models/base.model';

export class ViMonitorListItem
    extends BaseModel<ViMonitorListItem, ViMonitorListItemApi> implements AuditableModel<number>, LeftSidebarListItemConvertableModel {

    id: number;
    name: string;
    status: ViMonitorStatusEnum;
    questionCount: number;

    hidden: boolean;
    isFavourite: boolean;
    groupId?: number;

    createdDate: Date;
    modifiedDate: Date;

    createdByUserId?: number;
    modifiedByUserId?: number;

    constructor(apiModel?: ViMonitorListItemApi) {
        super();

        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
    }

    constructFromApiModel(apiModel: ViMonitorListItemApi) {

        this.id = +apiModel.id;
        this.name = apiModel.name ?? '';
        this.status = apiModel.status;
        this.questionCount = apiModel.questionCount ?? 0;

        this.hidden = !!apiModel.isHidden;
        this.isFavourite = !!apiModel.isFavourite;
        this.groupId = apiModel.displayGroupId ?? undefined;

        this.createdDate = new Date(apiModel.createdAt);
        this.modifiedDate = apiModel.updatedAt ? new Date(apiModel.updatedAt): null;
        this.createdByUserId = apiModel.createdByUserId;
        this.modifiedByUserId = apiModel.lastUpdatedByUserId;
    }

    constructDefault() {
        this.id = null;
        this.name = null;
        this.status = null;
        this.questionCount = 0;

        this.hidden = false;
        this.isFavourite = false;
        this.groupId = undefined;

        this.createdDate = null;
        this.modifiedDate = null;
        this.createdByUserId = null;
        this.modifiedByUserId = null;
    }

    toApiModel(): ViMonitorListItemApi {

        const apiModel: ViMonitorListItemApi = {
            id: String(this.id),
            name: this.name,
            status: this.status,
            questionCount: this.questionCount,
            isHidden: this.hidden,
            isFavourite: this.isFavourite,
            displayGroupId: this.groupId,
            createdAt: this.createdDate.getTime(),
            updatedAt: this.modifiedDate?.getTime(),
            createdByUserId: this.createdByUserId,
            lastUpdatedByUserId: this.modifiedByUserId
        };

        return apiModel;
    }

    clone(): ViMonitorListItem {
        return new ViMonitorListItem(this.toApiModel());
    }


    equals(other?: ViMonitorListItem): boolean {
        if (!other) {
            return false;
        }

        if (this.id !== other.id) {
            return false;
        }

        if (this.name !== other.name) {
            return false;
        }

        if (this.status !== other.status) {
            return false;
        }

        if (this.questionCount !== other.questionCount) {
            return false;
        }

        if (this.hidden !== other.hidden) {
            return false;
        }

        if (this.isFavourite !== other.isFavourite) {
            return false;
        }

        if (this.groupId !== other.groupId) {
            return false;
        }


        return true;
    }

    /** Filters out whichever of the hide/show and favorite/unfavorite pair doesn't apply, based on current state. */
    toLeftSidebarListItem(buttons?: LeftSidebarListItemButton[]): LeftSidebarListItem {
        if (buttons?.length) {
            buttons = buttons.filter(button => {
                if (this.hidden && button.key === ActionsEnum.hide) {
                    return false;
                }
                if (!this.hidden && button.key === ActionsEnum.show) {
                    return false;
                }
                if (this.isFavourite && button.key === ActionsEnum.favorite) {
                    return false;
                }
                if (!this.isFavourite && button.key === ActionsEnum.unfavorite) {
                    return false;
                }
                return true;
            });
        }

        const item = new LeftSidebarListItem();
        item.label = this.name;
        item.value = this.id;
        item.status = this.status;
        item.groupId = this.groupId;
        item.isFavorite = this.isFavourite;
        item.lastModifiedDate = this.modifiedDate.getTime();
        item.buttons = buttons ?? [];
        return item;
    }
}
